import { useQuery } from "@tanstack/react-query";
import { useOrg360Api } from "./useOrg360Api";

export interface Org360MetadataItem {
  id: string;
  full_name: string;
  metadata_type: string;
  file_path?: string;
}

/**
 * All components of a metadata type, sourced from Neo4j (the graph's source of
 * truth). Replaces deriving the item list from the degree-pruned graph payload,
 * which dropped low-connectivity types (e.g. Flow) entirely.
 */
export function useOrg360MetadataItems(selectedType?: string) {
  const { getJson, orgId } = useOrg360Api();

  return useQuery({
    queryKey: ["org360-items", orgId, selectedType ?? ""],
    queryFn: async () => {
      if (!selectedType) return [] as Org360MetadataItem[];
      const res = await getJson<{ ok: boolean; data: { items: Org360MetadataItem[] } }>(
        "/api/metadata/items",
        { org_id: orgId, metadata_type: selectedType, limit: "20000" },
      );
      return res?.data?.items ?? [];
    },
    enabled: !!orgId && !!selectedType,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
